export default {
  downtimeUrl: "https://www.kodland.org",
  parameters: {
    landing_id: "MyQFwd",
    segment: 51,
  },
  startPage: {
    image: {
      url: "/welcome/my_fwd_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/my_fwd_mob.png",
      style: {
        width: "100%",
      },
    },
    title:
      "Kami menjemput kanak-kanak berusia 8-17 tahun untuk menyertai kelas dalam talian reka bentuk grafik",
    subtitle:
      "Kanak-kanak akan mencuba kreativiti digital mereka: kartun, animasi, ilustrasi, pemodelan, 3D, reka bentuk",
    button: " Mulakan 🚀 ",
  },
  successPage: {
    title: "Pilih tarikh dan masa untuk mendapatkan pelajaran PERCUMA 🚀",
    subtitle: "Klik butang “📆 Tempah” dan dapatkan pelajaran.",
    button: "📆 Tempah"
  },
  stopPage: {
    image: "/welcome/quiz_stop_page.jpg",
    title: "Terima kasih kerana mempercayai platform pendidikan kami! Malangnya, tablet atau telefon tidak sesuai untuk mengikuti kelas kami. Kami berbesar hati untuk berjumpa anda di kelas kami pada masa akan datang!",
  },
  quizRotateBySteps: {
    1: {
      question: "Apakah mata pelajaran kegemaran anak anda?",
      answers: [
        "🔬 Sains",
        "🎨 Seni dan Reka Bentuk",
        "💻 Sains komputer",
        "🏛️ Ilmu budaya (Sejarah, Literasi, dll.)",
        "📐 Matematik",
        "💬 Ilmu Bahasa",
        "🤩 Semua di atas",
      ],
    },
    2: {
      question: "Bagaimana anak anda biasa mengisi masa lapangnya?",
      answers: [
        "📱 Bermain permainan di telefon atau komputer",
        "👽 Menonton kartun",
        "♟️ Bermain permainan sukan",
        "👨‍👩‍👧‍👦 Meluangkan masa dengan ahli keluarga",
        "👥 Meluangkan masa dengan rakan-rakan",
        "⛹️ Bermain permainan sukan",
        "🎨 Melakukan aktiviti seni: melukis, muzik, lakonan, dsb.",
      ],
    },
    3: {
      question:
        "Adakah anak anda menyertai aktiviti kokurikulum di luar pembelajaran sekolah?",
      answers: [
        "📚 Kelas yang meningkatkan prestasi akademik",
        "⛹️ Ya. Aktiviti sukan",
        "🎨 Ya. Kelas Seni",
        "💻 Ya. Kelas pengaturcaraan dan sains komputer",
        "🏕️ Ya. Pengakap",
        "✖️ Tidak. Anak tidak mempunyai masa untuk itu",
      ],
    },
    4: {
      question:
        "Adakah anda boleh menyambung ke kelas percubaan percuma dari komputer atau komputer riba?",
      answers: [
        "💻 Ya",
        {
          answer: "😐 Tidak",
          stopAnswer: true,
        },
      ],
    },
  },
};
